import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/** Combina classes resolvendo conflitos do Tailwind (a última vence). */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}

let idCounter = 0;

/**
 * Identificador estável para vincular `aria-describedby` / `aria-labelledby`.
 *
 * Preferimos `React.useId` nos componentes; esta função existe para os poucos
 * casos fora de componente (ex.: geração de ids em listas de descrição).
 */
export function nextId(prefix: string): string {
  idCounter += 1;
  return `${prefix}-${idCounter}`;
}

/** Junta ids de descrição ignorando os ausentes — `aria-describedby` aceita lista. */
export function describedBy(...ids: Array<string | false | null | undefined>): string | undefined {
  const list = ids.filter((id): id is string => typeof id === 'string' && id.length > 0);
  return list.length > 0 ? list.join(' ') : undefined;
}

/**
 * Anel de foco padrão do design system.
 * Centralizado para que NENHUM componente possa esquecer o indicador visível
 * (WCAG 2.4.7) — o `focus-visible` do CSS global é a rede de segurança, este é
 * o estilo intencional por componente.
 */
export const focusRing =
  'qc-focus-ring outline-none focus-visible:ring-2 focus-visible:ring-focus focus-visible:ring-offset-2 focus-visible:ring-offset-canvas';

/** Estado desabilitado consistente: opacidade + cursor + remoção de eventos. */
export const disabledStyles =
  'disabled:cursor-not-allowed disabled:opacity-55 data-[disabled]:cursor-not-allowed data-[disabled]:opacity-55';
